exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\np[data-v-73384726] {\n  color: #232323;\n  font-size: 1rem;\n  text-align: center;\n  margin-bottom: 2rem;\n}\n.pickl-btn[data-v-73384726] {\n    color: #ffffff;\n    text-decoration: none;\n    padding: 10px 15px;\n    border-radius: 40px;\n    font-size: 15px;\n    font-weight: 800;\n    display: inline-block;\n    background-color: #782b54;\n}\n", ""]);

// exports
